/* eslint-disable */
export default {
  start: 'Découverte rapide',
  skip: 'Ignorer',
  next: 'Suivant',
  finish: 'Terminer',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
